// components/MobileBottomNav.tsx
import { motion } from 'framer-motion';
import { FaHome, FaPalette, FaCalendarAlt, FaMapMarkerAlt, FaSpotify } from 'react-icons/fa';
import { AppView } from '../hooks/useAppNavigation';

const navItems = [
  { id: 'hero' as AppView, label: 'Inicio', icon: FaHome },
  { id: 'canvas' as AppView, label: 'Canvas', icon: FaPalette },
  { id: 'calendario' as AppView, label: 'Notes', icon: FaCalendarAlt },
  { id: 'maps' as AppView, label: 'Maps', icon: FaMapMarkerAlt },
  { id: 'spotify' as AppView, label: 'Spotify', icon: FaSpotify },
];

interface MobileBottomNavProps {
  currentView: AppView;
  onNavigate: (view: AppView) => void;
}

export const MobileBottomNav = ({ currentView, onNavigate }: MobileBottomNavProps) => {
  const isSpotifyView = currentView === 'spotify';

  return (
    <motion.nav 
      initial={{ y: 100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.5 }}
      className={`fixed bottom-0 left-0 right-0 z-50 transition-all duration-300 ${
        isSpotifyView 
          ? 'bg-black/90 border-t border-green-400/30' 
          : 'bg-white/20 backdrop-blur-lg border-t border-white/20'
      }`}
    >
      <div className="flex justify-around items-center py-2 pb-safe-area-inset-bottom">
        {navItems.map((item) => {
          const IconComponent = item.icon;
          const isActive = currentView === item.id;
          
          return (
            <button
              key={item.id}
              onClick={() => onNavigate(item.id)}
              className="flex flex-col items-center justify-center p-2 min-w-0 flex-1"
            >
              <motion.div
                whileTap={{ scale: 0.9 }}
                className={`flex flex-col items-center gap-1 transition-colors duration-300 ${
                  isActive 
                    ? isSpotifyView 
                      ? 'text-green-400' 
                      : 'text-secondary'
                    : isSpotifyView 
                      ? 'text-green-200/60 hover:text-green-300' 
                      : 'text-text-light hover:text-secondary'
                }`}
              >
                <IconComponent className="w-5 h-5" />
                <span className="text-xs font-medium truncate">{item.label}</span>
                
                {/* Indicador activo */}
                {isActive && (
                  <motion.div
                    layoutId="activeTab"
                    className={`w-1 h-1 rounded-full ${
                      isSpotifyView ? 'bg-green-400' : 'bg-secondary'
                    }`}
                    transition={{ type: "spring", damping: 30, stiffness: 300 }}
                  />
                )}
              </motion.div>
            </button>
          );
        })}
      </div>
    </motion.nav>
  );
};